import Api from "@src/api";
export default {
  getEvents(type, startTime, endTime) {
    const typeText = type ? `type=${type}&` : '';
    const startTimeText = startTime ? `startTime=${startTime}&` : '';
    const endTimeText = endTime ? `endTime=${endTime}` : '';

    return Api().get(`Calendar?${typeText}${startTimeText}${endTimeText}`);
  },
  setEvent(body) {
    return Api().post(`Calendar`, body);
  },
  updateEvent(body, id) {
    return Api().put(`Calendar/${id}`, body);
  },
  deleteEvent(id) {
    return Api().delete(`Calendar/${id}`);
  },
  getCalendarConfig() {
    return Api().get(`Calendar/CalendarConfig`);
  },
  setCalendarConfig(body) {
    return Api().post(`Calendar/UpdateCalendarConfig`, body);
  },
  addMemo(body,time,type) {
    return Api().post(`Calendar/Memo/${type}/${time}`, JSON.stringify(body),{
      headers: {
        'Content-Type': 'application/text+json'
      },
    });
  },
  getMemo(time) {
    return Api().get(`Calendar/Memo/${time}`);
  },

  // Day off
  getListDayOff() {
    return Api().get(`Calendar/Holiday`);
  },
  addListDayOff(data) {
    return Api().post(`Calendar/Holiday`,data);
  },
  getTimeConfig:() => {
    return Api().get("Calendar/TimeSetting");
  },
  addTimeConfig:(start,end) => {
    return Api().post(`Calendar/TimeSetting/${start}/${end}`);
  },
  getSyncStatusMail:() => {
    return Api().get(`Calendar/SyncStatus`);
  },
  updateSyncStatusMail:(status) => {
    return Api().put(`Calendar/SyncStatus/${status}`);
  },
};

